export default __webpack_public_path__ + "static/22-015a3214f0b5d6512f3d6fdcc28ba7b3.webp";